import landscape from './pro/landscape.json';
import portrait from './pro/portrait.json';
import square from './pro/square.json';
import init from './default.json';

export default {
  landscape,
  portrait,
  square,
  init,
};



// WEBPACK FOOTER //
// ./src/config/templates/layouts/pro.jsx